import { renderComponent } from '@ember/renderer';

type ComponentWithArgs<Args extends Record<string, unknown>> = abstract new (
  ...args: never[]
) => { args: Args };

interface RenderTooltipOptions<Args extends Record<string, unknown>> {
  args: Args;
  owner: object | undefined;
}

// Renders a component to an HTML string, for APIs like Highcharts formatters.
export default function renderTooltip<Args extends Record<string, unknown>>(
  component: ComponentWithArgs<Args>,
  { owner, args }: RenderTooltipOptions<Args>,
): string {
  const element = document.createElement('div');
  const result = renderComponent(component, { into: element, owner, args });
  const html = element.innerHTML;
  // Destroy the render right away or it would live as long as the owner.
  result.destroy();

  return html;
}
